module.exports = __webpack_public_path__ + "balanced-portfolio-light-touch-policy.6b27af71bce27846a8fe8b5d82a9cbfd.svg";